import { init as initRelay } from "../init-relay";
import { ConfluenceTemplateDetailsRelayPage } from "../pages/software/confluence/templates/confluence-template-details-relay-page";
import {
    ConfluenceTemplateDetailsRelayPageQuery,
    getConfluenceTemplateDetailsRelayPageQueryVars
} from "../templates/software/confluence/templates/confluence-templates-page/src/relay/confluence-template-details-relay-page.template";

initRelay(
    ConfluenceTemplateDetailsRelayPage,
    ConfluenceTemplateDetailsRelayPageQuery,
    getConfluenceTemplateDetailsRelayPageQueryVars(window.location)
);
